import { ConnectedPosition, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Injectable, Injector, StaticProvider } from '@angular/core';
import { NotificationsOverlayComponent } from './notifications-overlay.component';
import { NOTIFICATIONS_OVERLAY_DATA } from './notifications-overlay.tokens';

export interface NotificationsOverlayConfig {
  onClose?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationsOverlayService {
  constructor(
    private injector: Injector,
    private overlay: Overlay,
  ) {}

  open(target: HTMLElement, config: NotificationsOverlayConfig) {
    // Override default configuration
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(target as HTMLElement)
      .withPositions([
        {
          // here, top-left of the overlay is connected to bottom-left of the origin;
          // of course, you can change this object or generate it dynamically;
          // moreover, you can specify multiple objects in this array for CDK to find the most suitable option
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        } as ConnectedPosition,
        {
          // here, top-left of the overlay is connected to bottom-left of the origin;
          // of course, you can change this object or generate it dynamically;
          // moreover, you can specify multiple objects in this array for CDK to find the most suitable option
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        } as ConnectedPosition,
      ])
      .withPush(true);

    // Returns an OverlayRef which is a PortalHost
    const overlayReference = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      // width: 300,
    });

    return this.attachDialogContainer(overlayReference, config);
  }

  private attachDialogContainer(overlayReference: OverlayRef, config: NotificationsOverlayConfig) {
    const injector = this.createInjector(config, overlayReference);

    const containerPortal = new ComponentPortal(NotificationsOverlayComponent, undefined, injector);
    const containerReference: ComponentRef<NotificationsOverlayComponent> = overlayReference.attach(containerPortal);

    return containerReference.instance;
  }

  private createInjector(config: NotificationsOverlayConfig, overlayReference: OverlayRef) {
    const injectionTokens: StaticProvider = [];

    injectionTokens.push(
      { provide: OverlayRef, useValue: overlayReference },
      {
        provide: NOTIFICATIONS_OVERLAY_DATA,
        useValue: config,
      },
    );

    return Injector.create({ parent: this.injector, providers: injectionTokens });
  }
}
